<template>
  <div class="row">
    <div class="col-sm-5 fwfont">
      <div class="h-100">
        <!-- HH Current Month Table -->
        <half-hourly-advances-calander
          v-model="selectedDay"
          v-bind="HhMeterPoint"
          :month="currentMonth"
          select
          @input="showAdvances(selectedDay)"
        />
        <!-- HH Previous Month Table -->
        <half-hourly-advances-calander
          v-model="selectedDay"
          v-bind="HhMeterPoint"
          :month="previousMonth"
          select
          @input="showAdvances(selectedDay)"
        />
        <div class="col-12 text-center">
          <a
            role="button"
            class="btn btn-hc m-20"
            data-toggle="modal"
            data-target="#viewAllAdvances"
            >View All Advances</a
          >
        </div>
      </div>
    </div>
    <div id="advances_table_results" class="col-sm-7">
      <advances-table :selectedDate="selectedDay" />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import advancesMixin from "@/mixins/meterInfo/readings/advances.js";
import HalfHourlyAdvancesCalander from "./HalfHourlyAdvancesCalander";
import advancesTable from "./AdvancesView";

export default {
  name: "electricity-readings-hh",
  components: {
    HalfHourlyAdvancesCalander,
    advancesTable,
  },
  mixins: [advancesMixin],
  computed: {
    currentMonth() {
      return moment().startOf("month").format("YYYY-MM-DD");
    },
    previousMonth() {
      return moment()
        .startOf("month")
        .subtract(1, "month")
        .format("YYYY-MM-DD");
    },
  },
};
</script>